module.exports = __webpack_public_path__ + "img/1101837877.1ca29243.jpg";